import React from 'react' 

export default function Footer() {
  return (
    <>
      {/*
		<footer className="footer">
			<span>&copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold ">{`${APP_NAME}`}</span> <span className="mx-2 text-muted"> | </span><span>
				<a className="text-primary" href="/#" onClick={e => e.preventDefault()}>Terms of Service</a>
				<span className="mx-2 text-muted"> | </span>
				<a className="text-primary" href="/#" onClick={e => e.preventDefault()}>Privacy Policy</a>
			</span></span>
			
		</footer>
		*/}
    </>
  )
}

